import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './StaticCount.module.css'
import StaticCountItem from './StaticCountItem'

const StaticCount = ({
  items,
  separator,
  header,
  checked,
  onSelect,
  selectable,
}) => {
  const multiple = items && items.length > 1

  return (
    <div
      key={`static-count-${items.map((i) => i.title)}`}
      className={classNames(styles.container, {
        [styles.multiple]: multiple,
        [styles.separator]: separator,
      })}
    >
      {multiple && <div className={styles.header}> {header} </div>}
      {items.map((item, index) => (
        <StaticCountItem
          key={`static-count-${item.title}`}
          multiple={multiple}
          checked={checked[index]}
          onSelect={() => onSelect(index, !checked[index])}
          selectable={selectable}
          {...item}
        />
      ))}
    </div>
  )
}

StaticCount.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      count: PropTypes.number,
    }),
  ),
  separator: PropTypes.bool,
  selectable: PropTypes.bool,
  onSelect: PropTypes.func,
  checked: PropTypes.arrayOf(PropTypes.bool),
  header: PropTypes.string,
}

StaticCount.defaultProps = {
  items: [{ title: '', count: 0 }],
  separator: true,
  selectable: false,
  onSelect: () => {},
  checked: [false],
  header: '',
}

export default StaticCount
